 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"403":"403","404":"404","Profile":"Profile","step1":"step1","step2":"step2","Logs":"Logs","reports":"reports","sellaccessories":"sellaccessories","dashboard-patient-status":"dashboard-patient-status","paymentsgenerals":"paymentsgenerals","quotesgeneral":"quotesgeneral","clockin-check":"clockin-check","step3":"step3","External Lead":"External Lead","login":"login","end-of-step":"end-of-step","allergies":"allergies","medical-info-form":"medical-info-form","post-patient-information":"post-patient-information","post-surgery-patient-pick-information":"post-surgery-patient-pick-information","current-health-problems":"current-health-problems","emergncy-contact":"emergncy-contact","video-photo-autorization":"video-photo-autorization","check-list":"check-list","document-signing":"document-signing","patient-personal-details":"patient-personal-details","payments":"payments","quotes":"quotes","add-appointment":"add-appointment","notes":"notes","procedure-status":"procedure-status","relations":"relations","remove-patient":"remove-patient","btn-resend-docuemnts":"btn-resend-docuemnts","note-details":"note-details"}[chunkId]||chunkId) + "." + {"403":"6175a75e","404":"85d15eb6","Profile":"b0802a76","chunk-01e73c00":"07fe3d37","chunk-020c7b02":"6677377e","chunk-020df5f2":"7f784791","chunk-06b5ad16":"4931efd7","chunk-2d0aec6d":"dc0edc81","chunk-2d0de3b0":"5d4ff7ac","chunk-1bc7e9cd":"1f625297","chunk-02108bcc":"0bc1edb7","chunk-1d8e8b26":"b3130bf4","step1":"2561891a","step2":"902f943e","chunk-2fc2fb80":"e46eb80b","chunk-2cd3c4b7":"31a6e4f1","chunk-2d0b34d5":"5ca51a00","chunk-2d0c9adc":"3778f25c","chunk-38751a50":"315f2ae3","chunk-41c31a0a":"0a99438d","chunk-4cf5ec97":"e9f67bbb","chunk-62b1b79b":"b023da89","chunk-70caee82":"aeb97729","chunk-01e52304":"c54a1be6","chunk-069ee704":"92ace42f","chunk-0ff693d7":"f032614d","chunk-12f59cbe":"970e4447","chunk-2c315f04":"7a19ba97","chunk-2c4847b4":"834d690f","chunk-3c25632e":"77bf98c1","chunk-18128c36":"f61bf4b5","chunk-11f0d2e2":"58a077f3","chunk-22d7b1c6":"124837c3","chunk-4b1a9c55":"e9998f02","chunk-7b9f8531":"b3597559","chunk-2bc98b06":"59ecf1a3","chunk-2d229217":"e53b00ea","chunk-3aa68704":"88343247","chunk-42b18aa2":"0da6ffb9","chunk-4ec9af14":"da8ab4ae","chunk-5af29a35":"f0b1f7b9","chunk-763667e1":"38d2e296","Logs":"08b92efe","chunk-b94dc4ae":"25a1ead0","reports":"3eae2738","sellaccessories":"ba159115","chunk-54c6ec48":"0b9a4949","chunk-1ab52309":"720b586d","dashboard-patient-status":"38a00025","chunk-0729c8e2":"543d3ac4","chunk-0c977576":"e19ae7ab","paymentsgenerals":"814867c9","quotesgeneral":"99534dd6","chunk-22c01924":"86c64afb","clockin-check":"f27e1131","chunk-bc9b2f72":"c4c2405c","chunk-3b1d7ada":"7ead6bb6","chunk-7d6449f4":"f55b87d7","chunk-9ad07f86":"a4ec4280","chunk-b332ec9a":"06159a67","chunk-daef4348":"7c460866","chunk-ded9fe52":"64998aaa","chunk-effa1bec":"63fbc0b8","step3":"d27080b6","chunk-3f268d52":"6ade0dfd","chunk-4b264d33":"390604d9","chunk-854667a4":"44bced9f","chunk-9430adf4":"9e333574","External Lead":"e286f2dd","chunk-fdefac20":"69c7a834","chunk-7a7b010c":"c6aa3154","chunk-4411dab4":"4babd7db","chunk-9b0bc8ac":"96da8d97","chunk-c3780848":"8167e617","chunk-ffad491c":"30785034","chunk-7b91cf4f":"d9342a1b","chunk-93ff64ae":"82219b06","chunk-d283d97e":"f9347877","login":"85458cff","end-of-step":"11a22229","allergies":"52236c9d","medical-info-form":"e0e0ea33","post-patient-information":"1769b261","post-surgery-patient-pick-information":"6b3c2c3f","current-health-problems":"c05d6b55","emergncy-contact":"f313258c","video-photo-autorization":"db695f7b","chunk-2d216214":"521a5112","chunk-fff0f504":"7a1c8739","check-list":"39a202de","document-signing":"3df04207","patient-personal-details":"ae78e537","payments":"a79c4d45","quotes":"f8567390","add-appointment":"721916b4","notes":"b2301172","procedure-status":"27917927","relations":"34ba4178","remove-patient":"6843e3df","chunk-24fbf81d":"15d11c3c","btn-resend-docuemnts":"80474067","note-details":"3447d453"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Profile":1,"chunk-06b5ad16":1,"chunk-1bc7e9cd":1,"chunk-1d8e8b26":1,"step1":1,"chunk-2fc2fb80":1,"chunk-2cd3c4b7":1,"chunk-38751a50":1,"chunk-41c31a0a":1,"chunk-4cf5ec97":1,"chunk-62b1b79b":1,"chunk-70caee82":1,"chunk-069ee704":1,"chunk-0ff693d7":1,"chunk-18128c36":1,"chunk-11f0d2e2":1,"chunk-22d7b1c6":1,"chunk-4b1a9c55":1,"chunk-7b9f8531":1,"chunk-2bc98b06":1,"chunk-42b18aa2":1,"chunk-5af29a35":1,"chunk-763667e1":1,"Logs":1,"chunk-b94dc4ae":1,"reports":1,"sellaccessories":1,"chunk-54c6ec48":1,"chunk-1ab52309":1,"dashboard-patient-status":1,"chunk-0729c8e2":1,"chunk-0c977576":1,"paymentsgenerals":1,"quotesgeneral":1,"chunk-22c01924":1,"clockin-check":1,"chunk-bc9b2f72":1,"chunk-3b1d7ada":1,"chunk-7d6449f4":1,"chunk-9ad07f86":1,"chunk-ded9fe52":1,"chunk-effa1bec":1,"step3":1,"chunk-3f268d52":1,"chunk-4b264d33":1,"chunk-854667a4":1,"chunk-9430adf4":1,"External Lead":1,"chunk-fdefac20":1,"chunk-7a7b010c":1,"chunk-4411dab4":1,"chunk-9b0bc8ac":1,"chunk-ffad491c":1,"chunk-7b91cf4f":1,"chunk-d283d97e":1,"login":1,"allergies":1,"medical-info-form":1,"post-patient-information":1,"post-surgery-patient-pick-information":1,"current-health-problems":1,"emergncy-contact":1,"video-photo-autorization":1,"check-list":1,"document-signing":1,"patient-personal-details":1,"payments":1,"add-appointment":1,"notes":1,"btn-resend-docuemnts":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"403":"403","404":"404","Profile":"Profile","step1":"step1","step2":"step2","Logs":"Logs","reports":"reports","sellaccessories":"sellaccessories","dashboard-patient-status":"dashboard-patient-status","paymentsgenerals":"paymentsgenerals","quotesgeneral":"quotesgeneral","clockin-check":"clockin-check","step3":"step3","External Lead":"External Lead","login":"login","end-of-step":"end-of-step","allergies":"allergies","medical-info-form":"medical-info-form","post-patient-information":"post-patient-information","post-surgery-patient-pick-information":"post-surgery-patient-pick-information","current-health-problems":"current-health-problems","emergncy-contact":"emergncy-contact","video-photo-autorization":"video-photo-autorization","check-list":"check-list","document-signing":"document-signing","patient-personal-details":"patient-personal-details","payments":"payments","quotes":"quotes","add-appointment":"add-appointment","notes":"notes","procedure-status":"procedure-status","relations":"relations","remove-patient":"remove-patient","btn-resend-docuemnts":"btn-resend-docuemnts","note-details":"note-details"}[chunkId]||chunkId) + "." + {"403":"31d6cfe0","404":"31d6cfe0","Profile":"060902d7","chunk-01e73c00":"31d6cfe0","chunk-020c7b02":"31d6cfe0","chunk-020df5f2":"31d6cfe0","chunk-06b5ad16":"e2e0be35","chunk-2d0aec6d":"31d6cfe0","chunk-2d0de3b0":"31d6cfe0","chunk-1bc7e9cd":"11a86d41","chunk-02108bcc":"31d6cfe0","chunk-1d8e8b26":"af75896c","step1":"5e044c15","step2":"31d6cfe0","chunk-2fc2fb80":"b2bd27ea","chunk-2cd3c4b7":"cd280043","chunk-2d0b34d5":"31d6cfe0","chunk-2d0c9adc":"31d6cfe0","chunk-38751a50":"e0c72cbf","chunk-41c31a0a":"4c5280d5","chunk-4cf5ec97":"33ac40b1","chunk-62b1b79b":"c1556a07","chunk-70caee82":"d253099c","chunk-01e52304":"31d6cfe0","chunk-069ee704":"d37a810a","chunk-0ff693d7":"b22a661d","chunk-12f59cbe":"31d6cfe0","chunk-2c315f04":"31d6cfe0","chunk-2c4847b4":"31d6cfe0","chunk-3c25632e":"31d6cfe0","chunk-18128c36":"ecb7680e","chunk-11f0d2e2":"d5e56fa2","chunk-22d7b1c6":"b7136185","chunk-4b1a9c55":"f776fead","chunk-7b9f8531":"4633243a","chunk-2bc98b06":"8543c15e","chunk-2d229217":"31d6cfe0","chunk-3aa68704":"31d6cfe0","chunk-42b18aa2":"49ceeaa1","chunk-4ec9af14":"31d6cfe0","chunk-5af29a35":"49830f27","chunk-763667e1":"acd6c2b6","Logs":"89d6c2da","chunk-b94dc4ae":"9158f945","reports":"48106317","sellaccessories":"2207ebfe","chunk-54c6ec48":"440f92a8","chunk-1ab52309":"c4e70b9a","dashboard-patient-status":"ce4a20fb","chunk-0729c8e2":"42c8069c","chunk-0c977576":"4f8468b6","paymentsgenerals":"d6cd86fa","quotesgeneral":"629c7821","chunk-22c01924":"d65bd743","clockin-check":"3dc3a839","chunk-bc9b2f72":"207a10e0","chunk-3b1d7ada":"a9246001","chunk-7d6449f4":"a9246001","chunk-9ad07f86":"753afec9","chunk-b332ec9a":"31d6cfe0","chunk-daef4348":"31d6cfe0","chunk-ded9fe52":"d37a810a","chunk-effa1bec":"93a35707","step3":"887d1ba2","chunk-3f268d52":"6270ed5c","chunk-4b264d33":"6270ed5c","chunk-854667a4":"8a17a26e","chunk-9430adf4":"87fdfec7","External Lead":"1fdd8805","chunk-fdefac20":"5ac0de02","chunk-7a7b010c":"5c264204","chunk-4411dab4":"4a040f46","chunk-9b0bc8ac":"74d2f8a2","chunk-c3780848":"31d6cfe0","chunk-ffad491c":"49830f27","chunk-7b91cf4f":"73543a7c","chunk-93ff64ae":"31d6cfe0","chunk-d283d97e":"4c5280d5","login":"fb71fc67","end-of-step":"31d6cfe0","allergies":"19ede2b4","medical-info-form":"c4e70b9a","post-patient-information":"74d2f8a2","post-surgery-patient-pick-information":"c4e70b9a","current-health-problems":"19ede2b4","emergncy-contact":"19ede2b4","video-photo-autorization":"41101002","chunk-2d216214":"31d6cfe0","chunk-fff0f504":"31d6cfe0","check-list":"1551a4f2","document-signing":"3e4ced6b","patient-personal-details":"67cef242","payments":"3a510cd1","quotes":"31d6cfe0","add-appointment":"0edcdea2","notes":"e387b8b0","procedure-status":"31d6cfe0","relations":"31d6cfe0","remove-patient":"31d6cfe0","chunk-24fbf81d":"31d6cfe0","btn-resend-docuemnts":"41101002","note-details":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
